import React, { useEffect, useState } from "react";


const Banner = ({bannerImg, mobile}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const handleImageLoad = () => {
    setImagesLoaded((prev) => prev + 1);
  };
  useEffect(() => {
    if (imagesLoaded === 2) {
      setIsVisible(true);
    }
  }, [imagesLoaded]);


  return (
    <div className="md:min-h-screen h-600px relative ">
      <img
        src={bannerImg}
        className="absolute -z-10 hidden md:block  w-full h-full object-cover "
        alt=""
        onLoad={handleImageLoad}
      />
      {/* <img
        src={mobile}
        className="absolute -z-10 md:hidden  w-full h-[700px]  object-cover
        "
        alt=""
        onLoad={handleImageLoad}
      /> */}
      <div className="z-10 md:min-h-screen min-h-[40rem] flex flex-col gap-4 items-center justify-center">
        <div className="lg:mx-40">
          <h1
            className={`lg:text-4xl text-2xl  transition duration-[1500ms]  text-white py-3 font-bold bg-[rgba(0,0,0,0.3)] rounded-xl font-['Open_Sans'] text-center px-8 
            ${isVisible && "opacity-100"}
            `}>
            The most reliable agricultural commodities manufacturer and exporter
            of Myanmar.
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Banner;
